<template>
  <ResultsDateSelector
    v-if="visible"
    :grid="payload.appointment_grid"
    :start-date="startDate"
    :request-key="requestKey"
    :show-year="showYear"
    :mobile="mobile"
    :list-layout="listLayout"
    :long-dates="placement === 'map'"
    :go-to-date="goToDate"
    :availability="dateAvailability"
    @select-date="handleSelectDate"
  />
</template>

<script setup>
import { computed, ref } from "vue";
import { whenI18nReady } from "#ce/components/SpFinder/i18n";
import { useFinderResults } from "#ce/components/SpFinder/composables/useFinderResults";
import { useDateSelectorPlacement } from "./composables/useDateSelectorPlacement";
import { useListLayout } from "./composables/useListLayout";
import ResultsDateSelector from "./components/ResultsDateSelector.ce.vue";

const props = defineProps({
  /**
   * Where the selector sits: "header" above the results on wide screens, "list" at the top of the list on
   * small screens, "map" at the top of the map's result list on wide screens. Only the one that matches the
   * screen and view renders.
   *
   * @type {String}
   */
  placement: {
    type: String,
    default: "header",
    validator: (value) => ["header", "list", "map"].includes(value),
  },
});

const catalogsReady = ref(false);

function markCatalogsReady() {
  catalogsReady.value = true;
}

whenI18nReady.then(markCatalogsReady);

const { settings, payload, view, mobile, commands, request, startDate, requestKey } = useFinderResults();

const showYear = computed(() => payload.value?.slot_show_year || "never");
const goToDate = computed(() => Boolean(settings.value?.goToDate));

const { visible, display } = useDateSelectorPlacement({
  placement: () => props.placement,
  catalogsReady,
  settings,
  payload,
  view,
  mobile,
});
const listLayout = useListLayout(() => props.placement, view);

function dateAvailability(range) {
  return request("dateAvailability", range);
}

function handleSelectDate(date) {
  commands.showDate(date);
}
</script>

<style>
:host {
  display: v-bind(display);
}
</style>
